module.exports = __webpack_public_path__ + "img/face-good.ebb9c4c9.svg";